// import React from "react";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// const SkeletonLoader = ({
//   type,
//   count = 1,
//   height,
//   width,
//   bottomGap,
//   topGap,
//   rightGap,
// }) => {
//   switch (type) {
//     case "circle":
//       return (
//         <Skeleton
//           circle={true}
//           height={height || 50}
//           width={width || 50}
//           style={{
//             marginBottom: bottomGap,
//             marginTop: topGap,
//             marginRight: rightGap,
//           }}
//         />
//       );
//     case "text":
//       return (
//         <Skeleton
//           count={count}
//           height={height || 50}
//           width={width}
//           style={{
//             marginBottom: bottomGap,
//             marginTop: topGap,
//             marginRight: rightGap,
//           }}
//         />
//       );
//     case "heading":
//       return <Skeleton height={height || 30} width={width || "80%"} />;
//     case "paragraph":
//       return (
//         <div>
//           {[...Array(count)].map((_, idx) => (
//             <Skeleton
//               key={idx}
//               height={height || 20}
//               style={{ marginBottom: bottomGap, marginTop: topGap }}
//             />
//           ))}
//         </div>
//       );
//     default:
//       return <Skeleton height={height || 50} width={100} />;
//   }
// };

// export default SkeletonLoader;

import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = ({
  type = "default", // 'circle' | 'text' | 'heading' | 'paragraph' | 'default'
  count = 1,
  height,
  width,
  circle = false,
  borderRadius,
  inline = false,
  duration = 1.2,
  enableAnimation = true,
  containerClassName,
  containerTestId,
  style = {},
  className,
  baseColor = "#ebebeb",
  highlightColor = "#f5f5f5",
  // Margin/Gap props (your original)
  bottomGap,
  topGap,
  rightGap,
  leftGap,
  // Additional layout
  wrapper: Wrapper, // Custom wrapper component
}) => {
  // Combine style props
  const combinedStyle = {
    ...style,
    marginBottom: bottomGap,
    marginTop: topGap,
    marginRight: rightGap,
    marginLeft: leftGap,
  };

  // Shared skeleton props
  const skeletonProps = {
    count,
    height,
    width,
    circle,
    borderRadius,
    inline,
    duration,
    enableAnimation,
    containerClassName,
    containerTestId,
    style: combinedStyle,
    className,
    baseColor,
    highlightColor,
    wrapper: Wrapper,
  };

  switch (type) {
    case "circle":
      return (
        <Skeleton
          {...skeletonProps}
          circle={true}
          height={height || 50}
          width={width || 50}
        />
      );
    case "text":
      return <Skeleton {...skeletonProps} />;
    case "heading":
      return (
        <Skeleton
          {...skeletonProps}
          height={height || 30}
          width={width || "80%"}
        />
      );
    case "paragraph":
      return (
        <div>
          {[...Array(count)].map((_, idx) => (
            <Skeleton
              key={idx}
              {...skeletonProps}
              height={height || 20}
              width={width || "100%"}
              count={1}
            />
          ))}
        </div>
      );
    case "default":
    default:
      return (
        <Skeleton {...skeletonProps} height={height || 50} width={width} />
      );
  }
};

export default SkeletonLoader;
